import PptxGenJS from 'pptxgenjs';
import PowerPointSlideProcessor from '@app/services/export/ppt/slides/PowerPointSlideProcessor';
import { copyBold, copySmall, h3 } from '@app/services/export/ppt/variables/typography';
import {
	createBadgeForSlide,
	createFullScreenCroppedImageForSlide,
	createLogoForSlide,
	createPartnerLogoForSlide,
	getBadgeWidthFromText
} from '@app/services/export/ppt/utils/layoutUtils';
import { removeHtmlInString } from '@app/services/export/ppt/utils/formattingUtils';
import global from '@app/filters/global';
import IHighlightSlideData from '@app/types/data/slides/IHighlightSlideData';
import {
	colors,
	defaultViewPortPadding,
	elementSizes,
	presentationDimensions,
	spacing
} from '@app/services/export/ppt/variables/constants';

export default class PowerPointHighlightSlideProcessor extends PowerPointSlideProcessor<IHighlightSlideData> {
	public async processSlideData(): Promise<void> {
		const slide: PptxGenJS.Slide = this.presentation.addSlide();
		const metaDataText = [];
		const textArray = [];
		const blueBackgroundHeight = 1.2;

		if (this.slideData.headline) {
			textArray.push({ text: this.slideData.headline, options: { ...h3, breakLine: true } });
		}

		if (this.slideData.elevation) {
			metaDataText.push(global.formatElevation(this.slideData.elevation));
		}

		let operatingTimes = this.mapOperatingTimes(this.slideData.operatingTimes);
		operatingTimes = operatingTimes || this.slideData.operatingTime;

		if (operatingTimes) {
			metaDataText.push(operatingTimes);
		}

		if (this.slideData.price) {
			const annotation = this.slideData.priceAnnotation || '';
			metaDataText.push(`${global.formatPriceWithCurrency(this.slideData.price)} ${annotation}`);
		}

		if (metaDataText.length) {
			textArray.push({
				text: metaDataText.join('  ●  '),
				options: { ...copyBold, breakLine: !!this.slideData.travelGuideBenefits }
			});
		}

		if (this.slideData.travelGuideBenefits) {
			textArray.push({
				text: removeHtmlInString(this.slideData.travelGuideBenefits),
				options: { ...copySmall, paraSpaceBefore: spacing.default }
			});
		}

		createFullScreenCroppedImageForSlide(slide, this.slideData.image);

		slide.addText(textArray, {
			shape: 'rect',
			x: 0,
			y: presentationDimensions.h - blueBackgroundHeight,
			w: presentationDimensions.w,
			h: blueBackgroundHeight,
			color: colors.white,
			fill: { color: colors.blue, transparency: 15 },
			align: 'center',
			margin: [50, 50, 0, 0]
		});

		if (this.slideData.logo) {
			createPartnerLogoForSlide(slide, this.slideData.logo);
		}

		if (this.slideData.badgeText) {
			createBadgeForSlide(slide, this.slideData.badgeText, {
				x:
					presentationDimensions.w -
					getBadgeWidthFromText(this.slideData.badgeText) -
					defaultViewPortPadding.horizontal,
				y: presentationDimensions.h - blueBackgroundHeight - elementSizes.badgeHeight / 2
			});
		}

		createLogoForSlide(slide);
	}
}
